let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("aHG2I"), load("bJvam"), load("5dFdL")]).then(() => parcelRequire('5lHdk'));